import Page, { PageHero } from "../components/Page";
import SubNav from "../components/SubNav";
import Button from "../components/Button";
import { festival } from "../data/festival";
import { IconExternal } from "../components/icons";
import styles from "./GetInvolved.module.css";

const subNav = [
  { label: "Participate", path: "/participate", end: true },
  { label: "Get Involved", path: "/participate/get-involved" },
  { label: "Vending", path: "/participate/vending" },
  { label: "Sponsors", path: "/participate/sponsors" },
];

export default function GetInvolved() {
  return (
    <>
      <PageHero
        eyebrow="Hands on"
        title="Get Involved"
        lede="Volunteer for an 8-hour shift, join the street team, or install a piece of art beneath the cottonwoods."
        image="/photos/volunteers.jpg"
      />
      <SubNav items={subNav} />

      <Page>
        <article className={styles.section}>
          <div className={styles.body}>
            <span className={styles.eyebrow}>Volunteers</span>
            <h2 className={styles.h2}>Trade an 8-hour shift for a 3-day pass.</h2>
            <p>
              Volunteers are the festival. In exchange for a minimum 8-hour shift,
              you get free festival admission. There is a job for every ability —
              gates, hospitality, kids' tent, sound assist, artist green room, the
              recycling crew, and a dozen others.
            </p>
            <ul className={styles.list}>
              <li>Free festival admission with an 8-hour shift</li>
              <li>$100 deposit returned in full after festival completion</li>
              <li>Car camping included; RVs and trailers require a separate ticket</li>
              <li>Questions? Email <a href={`mailto:${festival.emailVolunteer}`}>{festival.emailVolunteer}</a></li>
            </ul>
            <div className={styles.cta}>
              <Button href="https://signup.com/go/ybkXmHE" variant="primary">
                2026 Volunteer Application
              </Button>
            </div>
          </div>
          <div className={styles.media}>
            <img src="/photos/volunteers.jpg" alt="Festival volunteers" loading="lazy" />
          </div>
        </article>

        <article className={[styles.section, styles.flip].join(" ")}>
          <div className={styles.body}>
            <span className={styles.eyebrow}>Street Team</span>
            <h2 className={styles.h2}>Spread the word, get the perks.</h2>
            <p>
              Hand out flyers. Tell your friends. Post the lineup. Wear the shirt at
              your local show. Street-team perks include guest-list comps, festival
              merch, and other small but real things you can wave around.
            </p>
            <div className={styles.cta}>
              <Button href={`mailto:${festival.email}?subject=Street%20Team`} variant="dark">
                Join the Street Team
              </Button>
            </div>
          </div>
          <div className={[styles.media, styles.cover].join(" ")}
               style={{ backgroundImage: "url(/photos/festival-1.jpg)" }} />
        </article>

        <article className={styles.section}>
          <div className={styles.body}>
            <span className={styles.eyebrow}>Art Installations</span>
            <h2 className={styles.h2}>Show your work to thousands.</h2>
            <p>
              We're seeking interactive installations using light, sculpture,
              projection, or mixed media — built for an outdoor festival environment
              and a curious, dancing audience. Selected artists receive credentials,
              on-site support, and a meaningful platform.
            </p>
            <p>
              <strong>Application deadline:</strong> June 15, 2026
            </p>
            <div className={styles.cta}>
              <Button
                href="https://docs.google.com/forms/d/e/1FAIpQLScf5BLJ8AtUM2NkXKRZbaakB37IP5vJH6eIaOoGwiREs23J8A/viewform"
                variant="primary"
              >
                Submit Art Proposal <IconExternal />
              </Button>
            </div>
          </div>
          <div className={[styles.media, styles.cover].join(" ")}
               style={{ backgroundImage: "url(/photos/festival-3.jpg)" }} />
        </article>
      </Page>
    </>
  );
}
